
      // A signed-in reload asks for the session check, and on Home for the
      // agenda, while the application code loads. The build bundles this
      // small module into the entry script itself.
      import { startBootPrefetch } from '/src/platform/lib/bootPrefetch.ts';

      startBootPrefetch();

      // A failed delivery inside the entry's static import graph rejects this
      // import. Reload the document so the browser creates a new module map;
      // retrying the same import in place can reuse the failed module entry.
      function loadApplicationModule() {
        import('/src/main.tsx').catch(error => {
          if (window.rudiScheduleBootReload && window.rudiScheduleBootReload()) return;
          const root = document.getElementById('root');
          if (root && !root.hasChildNodes()) {
            root.innerHTML = `<main style="min-height:100vh;display:grid;place-items:center;padding:20px;font-family:sans-serif;text-align:center">
              <div><h1>Failed to load application</h1>
              <p>The application files could not be loaded. Reload the page to try again.</p>
              <button type="button" style="border-radius:1.5rem" onclick="window.location.reload()">Reload Page</button></div>
            </main>`;
          }
          console.error('[Rudi] Application module failed to load:', error);
        });
      }
      loadApplicationModule();
    